/* Love U Forever — Hero Section JS
   Carousel, header dark-mode, Shopify editor support */

(function () {
  'use strict';

  function init() {
    var hero = document.querySelector('[data-hero-variant]');
    if (!hero) return;

    var variant = hero.dataset.heroVariant;

    /* ─── Header dark mode (Cinema only) ─── */
    var header = document.getElementById('header');
    if (header) {
      header.classList.remove('on-dark');
      if (variant === 'cinema') header.classList.add('on-dark');
    }

    /* ─── Product Carousel (Editorial only) ─── */
    if (variant === 'editorial') initCarousel(hero);
  }

  function initCarousel(hero) {
    var carousel = hero.querySelector('[data-hero-carousel]');
    if (!carousel) return;

    var slides = carousel.querySelectorAll('.ed-slide');
    var slideLinks = carousel.querySelectorAll('.ed-slide-link');
    var dots = hero.querySelectorAll('[data-dot-index]');
    var prevBtn = hero.querySelector('[data-carousel-prev]');
    var nextBtn = hero.querySelector('[data-carousel-next]');

    /* Data for floating labels */
    var blocks = [];
    for (var i = 0; i < slides.length; i++) {
      var s = slides[i];
      blocks.push({
        name: s.getAttribute('data-product-name') || '',
        id: s.getAttribute('data-product-id') || '',
        meta: s.getAttribute('data-product-meta') || '',
        price: s.getAttribute('data-product-price') || ''
      });
    }

    if (slides.length < 2) return;

    var current = 0;
    var timer = null;
    var INTERVAL = 5500;

    function goTo(index) {
      slides[current].classList.remove('active');
      if (slideLinks[current]) slideLinks[current].classList.remove('active');
      if (dots[current]) dots[current].classList.remove('active');

      current = (index + slides.length) % slides.length;

      slides[current].classList.add('active');
      if (slideLinks[current]) slideLinks[current].classList.add('active');
      if (dots[current]) dots[current].classList.add('active');

      /* Update floating labels */
      var numEl = hero.querySelector('[data-carousel-num]');
      var nameEl = hero.querySelector('[data-carousel-name]');
      var idEl = hero.querySelector('[data-carousel-id]');
      var metaEl = hero.querySelector('[data-carousel-meta]');
      var priceEl = hero.querySelector('[data-carousel-price] .big');

      if (numEl) numEl.textContent = String(current + 1).padStart(2, '0');
      if (nameEl && blocks[current]) nameEl.textContent = blocks[current].name;
      if (idEl && blocks[current]) idEl.textContent = blocks[current].id;
      if (metaEl && blocks[current]) metaEl.textContent = blocks[current].meta;
      if (priceEl && blocks[current]) priceEl.textContent = blocks[current].price;

      resetTimer();
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function resetTimer() {
      clearInterval(timer);
      timer = setInterval(next, INTERVAL);
    }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.dotIndex, 10));
      });
    });

    /* Pause on hover */
    carousel.addEventListener('mouseenter', function () { clearInterval(timer); });
    carousel.addEventListener('mouseleave', resetTimer);

    /* Start auto-advance */
    timer = setInterval(next, INTERVAL);
  }

  /* Initial load */
  init();

  /* Shopify theme editor: re-init on section reload */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector('[data-hero-variant]')) {
        init();
      }
    });
  }

})();
